import type { Translations } from './types';
import en from './en';
import es from './es';

export type { Translations };

// Brand names that should render the Spanish UI.
// Add new Spanish brand names to this set as they are created.
export const SPANISH_BRANDS = new Set<string>([
  'empeno'
]);

const isSpanishBrand = (brand: string | null): boolean =>
  SPANISH_BRANDS.has(brand?.toLowerCase().trim() ?? '');

export const getTranslations = (brand: string | null): Translations =>
  isSpanishBrand(brand) ? es : en;

export type StoreCountry = 'US' | 'MX';

// Which official store list the widget uses: Mexico stores for the Spanish
// brands, US stores for every other brand.
export const getStoreCountry = (brand: string | null): StoreCountry =>
  isSpanishBrand(brand) ? 'MX' : 'US';
